import { render, staticRenderFns } from "./OrganisationRegistration.vue?vue&type=template&id=0925bb6c&scoped=true"
import script from "./OrganisationRegistration.vue?vue&type=script&lang=js"
export * from "./OrganisationRegistration.vue?vue&type=script&lang=js"
import style0 from "./OrganisationRegistration.vue?vue&type=style&index=0&id=0925bb6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0925bb6c",
  null
  
)

export default component.exports